import { NotSelected } from "../../../Constant/Setting";
import { User } from "../../Types/User";
import { Store } from "../Store.dt";
import { DELETE_USER_DATA, SET_USER_DATA } from "./UserTypes";

export const userInitial:User = {
    email: "",
    full_name: "",
    password: "",
    is_active:true,
    is_superuser:false,
    organization_id:NotSelected,
    subscription:"",
    role:"user"
}
export function UserReducer(state=userInitial, action:Store){
    switch(action.type){
        case SET_USER_DATA:
            return {...action.payload}
        case DELETE_USER_DATA:
            return state
        default:
            return state
    }
}